import type { CollectionModelDrawableMask, MaskSvgDrawableNode } from '../../model/collection/drawable/mask.drawable';
import type { SVGRenderOptions } from '../draw/svg/svg.render';
import { m } from '../mithril';
import { ClassNames } from '../theme';

export class MaskSVGDraw {
	static view(node: CollectionModelDrawableMask, options: SVGRenderOptions) {
		if (!options.isInsightMaskVisible) {
			options.draw.log.debug(
				{
					drawable: node.id,
					visibleInsightMasks: options.draw.state.visibleInsightMasks,
				},
				'Masks not rendered because isInsightMaskVisible is false. This is normal when the mask button is disabled. If the mask button is enabled, check the "feature.insight.ahoa" token is enabled, user is IKE Analyst, and that the mask drawable has a parsed SVG.'
			);
			return null;
		}

		if (!options.insightMaskTypesVisible) {
			options.draw.log.warn(
				{ drawable: node.id },
				'Masks not rendered because insightMaskTypesVisible is false. Check the "feature.insight.ahoa" token is enabled, and that the user is IKE Analyst.'
			);
			return null;
		}

		const svgGroups = node.getVisibleSvgDetectionGroups(options.insightMaskTypesVisible ?? [], options.draw.log);
		if (!svgGroups) {
			return null;
		}

		// Assume one group for each object type
		const detectionClassGroups = options.insightMaskTypesVisible.map((detectionClass) => {
			return svgGroups.find((g) => g.id === detectionClass);
		});

		//TODO: need to sort each shape by y position
		const detectionClassGroupShapes = detectionClassGroups
			.filter(Boolean)
			.map((group) => {
				if (!group) {
					return null;
				}
				return group.g.map((item) => {
					return getShapes(item, group.id);
				});
			})
			.filter(Boolean);

		if (!detectionClassGroupShapes.length) {
			options.draw.log.warn(
				{
					detectionClassGroups,
					detectionClassGroupShapes,
				},
				'Masks SVG contained detection groups but none of them contained detection shapes'
			);
		}

		return m(
			'g',
			{
				className: ClassNames.mask,
				id: `mask-${node.id}`,
			},
			[detectionClassGroupShapes]
		);
	}
}

function getShapes(item: MaskSvgDrawableNode, type: string) {
	const polylineNode = item.polyline
		? m('polyline', {
				id: item.polyline?.id,
				points: item.polyline?.points,
				style: {
					'pointer-events': 'none',
				},
			})
		: null;
	const pathNode = item.path
		? m('path', {
				id: item.path?.id,
				d: item.path?.d,
				style: {
					'pointer-events': 'none',
				},
			})
		: null;
	if (!polylineNode && !pathNode) {
		return null;
	}
	return m(
		'g',
		{
			className: type,
			id: item.id,
		},
		[polylineNode, pathNode]
	);
}
